import produce from "immer";
import {
  FETCH_PACKAGES,
  FETCH_PACKAGES_FAILURE,
  FETCH_PACKAGES_SUCCESS,
  //
  SET_CART_DATA,
  //
  TOGGLE_CONFIRM_MODAL,
  //
  CREATE_PAYMENT,
  CREATE_PAYMENT_SUCCESS,
  CREATE_PAYMENT_FAILURE,
  //
  ADD_TRANSACTION,
  ADD_TRANSACTION_SUCCESS,
  ADD_TRANSACTION_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingPackages: false,
  packages: [],
  cartData: {},
  confirmModal: { open: false },
  isCreatingIntent: false,
  intent: {},
  isAddtingTransaction: false,
};

const PackageReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_PACKAGES:
        draft.isFetchingPackages = true;
        draft.packages = [];
        break;
      case FETCH_PACKAGES_SUCCESS:
        draft.isFetchingPackages = false;
        draft.packages = action.payload;
        break;
      case FETCH_PACKAGES_FAILURE:
        draft.isFetchingPackages = false;
        draft.packages = [];
        break;

      case SET_CART_DATA:
        draft.cartData = action.payload;
        break;

      case TOGGLE_CONFIRM_MODAL:
        draft.confirmModal = action.payload;
        break;

      case CREATE_PAYMENT:
        draft.isCreatingIntent = true;
        draft.intent = {};
        break;
      case CREATE_PAYMENT_SUCCESS:
        draft.isCreatingIntent = false;
        draft.intent = action.payload;
        break;
      case CREATE_PAYMENT_FAILURE:
        draft.isCreatingIntent = false;
        draft.intent = {};
        break;

      case ADD_TRANSACTION:
        draft.isCreatingIntent = true;
        break;
      case ADD_TRANSACTION_SUCCESS:
        draft.isCreatingIntent = false;
        break;
      case ADD_TRANSACTION_FAILURE:
        draft.isCreatingIntent = false;
        break;

      default:
        return state;
    }
  });

export default PackageReducer;
